import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SEEN_KEY = 'sa_notif_last_seen';

export function useSaNotifications(enabled) {
    const { session } = useAuth();
    const [items, setItems] = useState([]);
    const [unread, setUnread] = useState(0);

    const load = useCallback(async () => {
        if (!enabled || !session?.access_token) return;
        try {
            const since = localStorage.getItem(SEEN_KEY);
            const r = await axios.get(`${API}/super-admin/notifications`, {
                headers: { Authorization: `Bearer ${session.access_token}` },
                params: since ? { since } : {},
            });
            setItems(r.data.items || []);
            setUnread(r.data.unread_count || 0);
        } catch { /* silent — polling */ }
    }, [enabled, session?.access_token]);

    useEffect(() => {
        if (!enabled) return;
        load();
        const t = setInterval(load, 30000);
        return () => clearInterval(t);
    }, [enabled, load]);

    const markAllRead = useCallback(() => {
        localStorage.setItem(SEEN_KEY, new Date().toISOString());
        setUnread(0);
    }, []);

    return { items, unread, markAllRead, refresh: load };
}
